import { EventEmitter, Injectable } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuServiceProvider {


  private showMenu: any;
  public _showMenu = new EventEmitter<boolean>();
  public select_group = new EventEmitter<number | null>();
  public select_sub_group = new EventEmitter<number | null>();

  private _fullscreen: boolean = false;
  public hideFooter = new BehaviorSubject<boolean>(this._fullscreen);
  currentHideFooter = this.hideFooter.asObservable();

  private selectedPage = new BehaviorSubject<string>("");
  selectedPageObservable$ = this.selectedPage.asObservable();

  private activeModule = new BehaviorSubject<string>("capacitacion");
  activeModule$ = this.activeModule.asObservable();

  public _showMenuPerformance = new EventEmitter<boolean>();
  private showMenuPerformance : any;

  constructor() {
    this.select_group.subscribe(index => {
      localStorage.setItem('select_group', JSON.stringify(index) )
    });
    this.select_sub_group.subscribe(index => {
      localStorage.setItem('select_sub_group', JSON.stringify(index))
    });
  }

  setSelectedPageRoute(route: string) {
      this.selectedPage.next(route);
      localStorage.setItem('select_page', route);
  }

  changeHideFooter(state:boolean) {
    this.hideFooter.next(state);
  }

  public getShowMenu(): any {
    return this.showMenu;
  }

  public setShowMenu(showMenu:any) {
    this.showMenu = showMenu;
  }

  navigateToModule(module: string) {
    localStorage.setItem("currentModule", module);
    this.activeModule.next(module);

  }

}
